import React from 'react';
import { Box, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const LogoText = styled(Typography)`
    font-size: 2rem;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.32px;
    line-height: 2rem;
`;

interface IProps {
    className?: string;
}

const BaseLogo = ({ className }: IProps) => {
    const { t } = useTranslation();

    return (
        <Box alignItems="center" className={className} display="flex">
            <Box
                alignItems="center"
                className="logoWrapper"
                display="flex"
                height="65px"
                mr={3}
                width="95px"
            >
                <svg
                    height="100%"
                    style={{
                        fillRule: 'evenodd',
                        clipRule: 'evenodd',
                        strokeLinejoin: 'round',
                        strokeMiterlimit: 2,
                    }}
                    viewBox="0 0 64 45"
                    width="100%"
                >
                    <g
                        id="Artboard1"
                        transform="matrix(1.01587,0,0,1.07187,0,-1.07187)"
                    >
                        <rect
                            height="41.743"
                            style={{ fill: 'none' }}
                            width="63"
                            x="0"
                            y="1"
                        />
                        <g
                            id="Group_836"
                            transform="matrix(0.984375,0,0,0.93295,-194.933,-370.031)"
                        >
                            <g id="Group_562">
                                <g id="Group_205">
                                    <path
                                        d="M207.854,415C206.757,415 205.854,414.097 205.854,413C205.859,408.362 209.674,404.546 214.312,404.541C215.409,404.541 216.312,405.444 216.312,406.541C216.312,407.638 215.409,408.541 214.312,408.541C211.867,408.544 209.857,410.555 209.854,413C209.854,414.097 208.951,415 207.854,415Z"
                                        id="Path_669"
                                        style={{
                                            fillRule: 'nonzero',
                                        }}
                                    />
                                    <path
                                        d="M240.386,415C239.289,415 238.386,414.097 238.386,413C238.391,408.362 242.207,404.546 246.845,404.541C247.942,404.541 248.845,405.444 248.845,406.541C248.845,407.638 247.942,408.541 246.845,408.541C244.4,408.544 242.389,410.555 242.386,413C242.386,414.097 241.483,415 240.386,415Z"
                                        id="Path_670"
                                        style={{
                                            fillRule: 'nonzero',
                                        }}
                                    />
                                </g>
                            </g>
                            <path
                                d="M229.249,441.439C227.068,441.437 224.912,440.978 222.92,440.09C222.179,439.779 221.695,439.05 221.695,438.246C221.695,437.149 222.598,436.246 223.695,436.246C223.987,436.246 224.276,436.31 224.541,436.434C230.178,438.952 236.888,436.509 239.587,430.957C239.922,430.272 240.621,429.836 241.384,429.836C242.481,429.836 243.384,430.739 243.384,431.836C243.384,432.141 243.314,432.441 243.18,432.715C240.593,438.041 235.17,441.437 229.249,441.439Z"
                                id="Path_671"
                                style={{
                                    fillRule: 'nonzero',
                                }}
                            />
                            <g id="Group_833" />
                            <g id="Group_834" />
                            <path
                                d="M261.172,406.438C261.172,406.436 261.172,406.435 261.172,406.433C261.172,404.609 259.671,403.108 257.847,403.108C257.392,403.108 256.942,403.201 256.525,403.382C253.974,400.436 250.263,398.74 246.366,398.74C241.742,398.74 237.431,401.127 234.977,405.046C232.062,402.995 228.149,402.995 225.234,405.046C222.78,401.126 218.469,398.739 213.844,398.739C209.945,398.739 206.232,400.436 203.681,403.385C203.257,403.197 202.798,403.099 202.334,403.099C200.512,403.099 199.013,404.599 199.013,406.42C199.013,407.609 199.65,408.71 200.681,409.301C200.461,410.275 200.35,411.271 200.35,412.27C200.35,419.668 206.437,425.755 213.835,425.755C221.233,425.755 227.32,419.668 227.32,412.27C227.32,411.118 227.173,409.971 226.881,408.857C226.904,408.835 226.931,408.82 226.954,408.797C228.737,407.107 231.57,407.116 233.342,408.817C233.046,409.939 232.896,411.095 232.896,412.256C232.896,419.65 238.981,425.735 246.375,425.735C253.769,425.735 259.854,419.65 259.854,412.256C259.854,411.26 259.744,410.267 259.525,409.296C260.541,408.704 261.17,407.614 261.172,406.438ZM213.84,421.7C208.638,421.7 204.358,417.42 204.358,412.218C204.358,407.016 208.638,402.736 213.84,402.736C219.042,402.736 223.322,407.016 223.322,412.218C223.317,417.418 219.04,421.695 213.84,421.7ZM246.371,421.7C241.169,421.7 236.889,417.42 236.889,412.218C236.889,407.016 241.169,402.736 246.371,402.736C251.573,402.736 255.853,407.016 255.853,412.218C255.848,417.418 251.571,421.695 246.371,421.7Z"
                                id="Path_685"
                                style={{
                                    fillRule: 'nonzero',
                                }}
                            />
                        </g>
                    </g>
                </svg>
            </Box>

            <LogoText color="primary">
                {t('common.siteTitle_1')}{' '}
                <Box component="span" display="block">
                    {t('common.siteTitle_2')}
                </Box>
            </LogoText>
        </Box>
    );
};

export const Logo = styled(BaseLogo)`
    svg path {
        fill: ${({ theme }) => theme.palette.primary.main};
    }
`;
